import React from 'react';
import { TextField } from '@mui/material';

interface DenyPatternsFieldProps {
  patterns: string[];
  onChange: (patterns: string[]) => void;
}

/** One rule per line: `[ANY|WRITE] /path`, where `*` is one path segment and `**` is anything. */
export const DenyPatternsField: React.FC<DenyPatternsFieldProps> = ({ patterns, onChange }) => (
  <TextField
    label="Extra blocked API paths"
    multiline
    minRows={3}
    fullWidth
    value={patterns.join('\n')}
    onChange={(event) => onChange(event.target.value.split('\n'))}
    placeholder={'WRITE /v1/admin/users/**\n/v1/admin/some-report/*'}
    helperText="One rule per line: [ANY|WRITE] /path. * matches one path segment, ** matches anything. A bare path blocks reads and changes (ANY); WRITE blocks changes only. These add to the built-in blocks, which cannot be removed."
    inputProps={{ spellCheck: false, className: 'font-mono text-sm' }}
  />
);
